import Vue from 'vue'
import Router from 'vue-router'
import { store } from '../store'

import Accueil from '../components/Accueil'

const Apropos = resolve => {
  require.ensure(['../components/apropos/Apropos'], () => {
    resolve(require('../components/apropos/Apropos'));
  });
};
const Connection = resolve => {
  require.ensure(['../components/connection/Connection'], () => {
    resolve(require('../components/connection/Connection'));
  });
};
const Contact = resolve => {
  require.ensure(['../components/contact/Contact'], () => {
    resolve(require('../components/contact/Contact'));
  });
};
const HistoriqueSms = resolve => {
  require.ensure(['../components/historique_sms/HistoriqueSms'], () => {
    resolve(require('../components/historique_sms/HistoriqueSms'));
  });
};
const MesContacts = resolve => {
  require.ensure(['../components/mes_contacts/MesContacts'], () => {
    resolve(require('../components/mes_contacts/MesContacts'));
  });
};
const MonCompte = resolve => {
  require.ensure(['../components/mon_compte/MonCompte'], () => {
    resolve(require('../components/mon_compte/MonCompte'));
  });
};
const NouveauSms = resolve => {
  require.ensure(['../components/nouveau_sms/NouveauSms'], () => {
    resolve(require('../components/nouveau_sms/NouveauSms'));
  });
};
const PaysDisponible = resolve => {
  require.ensure(['../components/pays_disponible/PaysDisponible'], () => {
    resolve(require('../components/pays_disponible/PaysDisponible'));
  });
};
const Tarification = resolve => {
  require.ensure(['../components/tarification/Tarification'], () => {
    resolve(require('../components/tarification/Tarification'));
  });
};
const NouvelEmail = resolve => {
  require.ensure(['../components/nouvel_email/NouvelEmail'], () => {
    resolve(require('../components/nouvel_email/NouvelEmail'));
  });
};

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Accueil',
      component: Accueil ,
    },
    {
      path: '/apropos',
      name: 'Apropos',
      component: Apropos
    },
    {
      path: '/connection',
      name: 'Connection',
      component: Connection,
      beforeEnter (to, from, next) {
        if(store.getters.getUtilisateurToken){
          router.go(-1)
        }else {
          next()
        }
      },
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/historique-sms',
      name: 'HistoriqueSms',
      component: HistoriqueSms,
      beforeEnter (to, from, next) {
        store.dispatch('tryAutoLogin').then().catch()
        store.getters.getUtilisateurToken ? next() : keepUserOnLoginPage(to, next)
      },
    },
    {
      path: '/mes-contacts',
      name: 'MesContacts',
      component: MesContacts,
      beforeEnter (to, from, next) {
        store.dispatch('tryAutoLogin').then().catch()
        store.getters.getUtilisateurToken ? next() : keepUserOnLoginPage(to, next)
      },
    },
    {
      path: '/mon-compte',
      name: 'MonCompte',
      component: MonCompte,
      beforeEnter (to, from, next) {
        store.dispatch('tryAutoLogin').then().catch()
        store.getters.getUtilisateurToken ? next() : keepUserOnLoginPage(to, next)
      },
    },
    {
      path: '/nouveau-sms',
      name: 'NouveauSms',
      component: NouveauSms,
      beforeEnter (to, from, next) {
        store.dispatch('tryAutoLogin').then().catch()
        store.getters.getUtilisateurToken ? next() : keepUserOnLoginPage(to, next)
      },
    },
    {
      path: '/nouvel-email',
      name: 'NouvelEmail',
      component: NouvelEmail,
      beforeEnter (to, from, next) {
        store.dispatch('tryAutoLogin').then().catch()
        store.getters.getUtilisateurToken ? next() : keepUserOnLoginPage(to, next)
      },
    },
    {
      path: '/pays-disponible',
      name: 'PaysDisponible',
      component: PaysDisponible
    },
    {
      path: '/tarification',
      name: 'Tarification',
      component: Tarification
    },
  ],
  mode: 'history',
})

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.configure({ easing: 'ease', speed: 700 });
    NProgress.start()
  }
  store.commit('setPrevRoute', from.path)
  store.commit('setCurrentRoute', to.path)

  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
  window.scrollTo(0,0);
})

let keepUserOnLoginPage = (to, next) => {
  store.commit('setTimeoutMessage', 10000)
  store.commit('setMessageApp', "Vous devez avoir un compte et vous connecter à votre compte avant d'accéder à cette page")
  store.commit('setStatusMessage', "warning")
  store.commit('setPrevRoute', to.path)
  next('/connection')
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js